
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/stock/articles",
      function () {
        return require("private-next-pages/ir/stock/articles.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/stock/articles"])
      });
    }
  